import { zhSG as common } from './features/common'
import { zhSG as login } from './features/login'
import Translation from './types'

export const zhSG: Translation = {
  translation: {
    features: {
      common,
      login,
    },
  },
}
